import { webApi } from '@mi-front/api-clients';
import { GetFragmentDto } from '@mi-front/core';
import {
  shouldPollUpload,
  useFragmentSocialUploadPolling,
} from './hooks/useFragmentSocialUploadPolling';
import { SocialExportUploadItemCard } from './SocialExportUploadItemCard';

interface Props {
  upload: webApi.FragmentSocialUploadItemDto;
  fragmentId: string;
  fragment: GetFragmentDto;
}

/**
 * Renders a single upload as a card in the panorama. When status is pending, polls via BFF getUploadById.
 * For all statuses renders SocialExportUploadItemCard.
 * Polling is limited to 1 hour from the publication time.
 */
export function SocialExportUploadItem({ upload: initialUpload, fragmentId, fragment }: Props) {
  const shouldPoll = shouldPollUpload(initialUpload);

  const polledQuery = useFragmentSocialUploadPolling(initialUpload.id, {
    enabled: shouldPoll,
  });

  const upload = shouldPoll ? (polledQuery.data ?? initialUpload) : initialUpload;

  return <SocialExportUploadItemCard upload={upload} fragmentId={fragmentId} fragment={fragment} />;
}
